import { getUrls } from '../../../../utils/url';

const { api } = getUrls();

const fetchIntegrationXML = () => {
    const launchUrl = `${api}/lti/course`;
    return `
        <?xml version="1.0" encoding="UTF-8"?>
        <cartridge_basiclti_link xmlns="http://www.imsglobal.org/xsd/imslticc_v1p0"
            xmlns:blti = "http://www.imsglobal.org/xsd/imsbasiclti_v1p0"
            xmlns:lticm ="http://www.imsglobal.org/xsd/imslticm_v1p0"
            xmlns:lticp ="http://www.imsglobal.org/xsd/imslticp_v1p0"
            xmlns:xsi = "http://www.w3.org/2001/XMLSchema-instance"
            xsi:schemaLocation = "http://www.imsglobal.org/xsd/imslticc_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticc_v1p0.xsd
            http://www.imsglobal.org/xsd/imsbasiclti_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imsbasiclti_v1p0.xsd
            http://www.imsglobal.org/xsd/imslticm_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticm_v1p0.xsd
            http://www.imsglobal.org/xsd/imslticp_v1p0 http://www.imsglobal.org/xsd/lti/ltiv1p0/imslticp_v1p0.xsd">
            <blti:launch_url>${launchUrl}</blti:launch_url>
            <blti:title>Class Course App</blti:title>
            <blti:description>Class Course App</blti:description>
            <blti:custom>
                <lticm:property name="cfz_debug_launch">false</lticm:property>
            </blti:custom>
            <blti:extensions platform="canvas.instructure.com">
                <lticm:property name="privacy_level">public</lticm:property>
                <lticm:options name="course_navigation">
                    <lticm:property name="visibility">public</lticm:property>
                    <lticm:property name="default">enabled</lticm:property>
                    <lticm:property name="enabled">true</lticm:property>
                </lticm:options>
            </blti:extensions>
        </cartridge_basiclti_link>
    `;
};

export default fetchIntegrationXML;
